export const getAriaLabelFromTemplate = (template, infoType, tariff) => {
  return template.replace('{INFOTYPE}', infoType)
    .replace('{TARIFF}', `${tariff.type} ${tariff.name}`);
};
